export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10747.b92e6bb6.jpg";